import { render, staticRenderFns } from "./ListadoPermisos.vue?vue&type=template&id=1c382758&scoped=true&"
import script from "./ListadoPermisos.vue?vue&type=script&lang=js&"
export * from "./ListadoPermisos.vue?vue&type=script&lang=js&"
import style0 from "./ListadoPermisos.vue?vue&type=style&index=0&id=1c382758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c382758",
  null
  
)

export default component.exports